export default __webpack_public_path__ + "static/media/kyc.b9d25e8f.png";